"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskQuery () {
        return AutoflowTaskQuery;
    },
    get AutoflowTaskQueryBase () {
        return AutoflowTaskQueryBase;
    },
    get AutoflowTaskQueryCompany () {
        return AutoflowTaskQueryCompany;
    },
    get AutoflowTaskQueryCompanyResponse () {
        return AutoflowTaskQueryCompanyResponse;
    },
    get AutoflowTaskQueryResponse () {
        return AutoflowTaskQueryResponse;
    },
    get AutoflowTaskQueryUser () {
        return AutoflowTaskQueryUser;
    },
    get AutoflowTaskQueryUserResponse () {
        return AutoflowTaskQueryUserResponse;
    },
    get TaskQueryConfig () {
        return TaskQueryConfig;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _engagement = require("../../engagement");
const _taskbase = require("./task-base");
const TaskQueryConfig = _taskbase.AutoflowTaskConfigBase;
const AutoflowTaskQueryBase = _taskbase.AutoflowTaskBase.extend({
    task_type: _zod.z.literal("query:"),
    config: TaskQueryConfig
});
const AutoflowTaskQueryUser = AutoflowTaskQueryBase.extend({
    task_type: _zod.z.literal("query:user"),
    config: TaskQueryConfig.extend({
        query: _engagement.CohortQueryModel
    })
});
const AutoflowTaskQueryUserResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskQueryUser).extend({
    outputs: _zod.z.instanceof(_bson.ObjectId).array()
});
const AutoflowTaskQueryCompany = AutoflowTaskQueryBase.extend({
    task_type: _zod.z.literal("query:company"),
    config: TaskQueryConfig.extend({
        query: _zod.z.any()
    })
});
const AutoflowTaskQueryCompanyResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskQueryCompany);
const AutoflowTaskQuery = _zod.z.discriminatedUnion("task_type", [
    AutoflowTaskQueryUser,
    AutoflowTaskQueryCompany
]);
const AutoflowTaskQueryResponse = _zod.z.discriminatedUnion("task_type", [
    AutoflowTaskQueryUserResponse,
    AutoflowTaskQueryCompanyResponse
]);
